import React, { useEffect, useState, useContext } from "react";
import classNames from "classnames";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../starek.css";
import StarekContext from "../context/StarekContext";
import DeletePlantModal from "../components/Wizards/DeletePlantModal";

const PlantViewCard = (props) => {
  const starekContext = useContext(StarekContext);

  const plant = props.plant;
  const [isSelected, setIsSelected] = useState(false);

  const [showDeletePlantModal, setShowDeletePlantModal] = useState(false);

  const handleShowDeletePlantModalClose = () => setShowDeletePlantModal(false);
  const handleShowDeletePlantModalShow = () => setShowDeletePlantModal(true);
  const handleShowModifyPlantModalShow = () => {
    props.onEdit(plant);
  };

  useEffect(() => {
    setIsSelected(plant.id === starekContext?.lastUsedPlant?.id);
  }, [plant]);

  const handleCardClick = (e) => {
    if (
      e.target.closest(".form-check-input") ||
      e.target.closest(".dropdown")
    ) {
      return;
    }
    props.onCardClick(plant);
  };
  const handleEllipsisClick = (e) => {
    e.stopPropagation();
  };

  const handleSliderChange = (e) => {
    e.stopPropagation();
    if (props.plantSelected) {
      props.plantSelected(e);
    }
  };
  return (
    <>
      <div
        className="col-md-3 d-flex align-items-stretch mb-3"
        onClick={handleCardClick}
      >
        <div
          className={classNames(
            "card border border-radius-15px w-100 p-3 d-flex flex-column h-100",
            { "border-color-198754": isSelected }
          )}
        >
          <div
            className={classNames("d-flex justify-content-end mt-n3 mr-n3", {
              "d-none": !isSelected,
            })}
          >
            <span className="plant-selected-text bg-color-198754 text-white px-2 py-1">
              Selected
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="bg-color-f7f5f5 border border-radius-50 px-10px py-8px">
              <i className="fa fa-industry text-secondary"></i>
            </div>
            <div className="dropdown">
              <i
                className="fa fa-ellipsis-v cursor-pointer"
                id={`dropdownMenuButton-${plant.id}`}
                data-bs-toggle="dropdown"
                onClick={handleEllipsisClick}
              ></i>
              <ul
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby={`dropdownMenuButton-${plant.id}`}
              >
                <li>
                  <span
                    className="dropdown-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowModifyPlantModalShow();
                    }}
                  >
                    <i className="fa fa-pen mr-3"></i>Edit
                  </span>
                </li>
                <li>
                  <span
                    className="dropdown-item text-danger"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowDeletePlantModalShow();
                    }}
                  >
                    <i className="fa fa-trash-alt mr-3"></i>Delete
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="font-weight-bold mt-4 mb-2">{plant.name}</div>
          <div>{plant.description}</div>
          <hr className="mx-n3 mt-auto" />
          <div className="d-flex justify-content-between align-items-center">
            <div className="font-weight-bold">Active</div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="is_plant_active"
                defaultChecked={plant.isSelected}
                onChange={handleSliderChange}
              />
            </div>
          </div>
        </div>
      </div>
      {showDeletePlantModal && (
        <DeletePlantModal
          show={showDeletePlantModal}
          handleClose={handleShowDeletePlantModalClose}
          plantData={plant}
          onSuccess={() => props.onSuccess()}
        />
      )}
    </>
  );
};
export default PlantViewCard;
